import {
  type FeatureFlag,
  useNinetailedFeatureFlag
} from '@ecomm/shared-ninetailed'
import { localStorage } from '@simplisafe/ewok'

export const isPayPalExperienceEnabled = (featureFlag: FeatureFlag) => {
  return localStorage.get('PAYPAL_TEST') === 'true' || featureFlag.isVariant
}

export const usePaypalFeatureFlagData = () =>
  useNinetailedFeatureFlag({ baselineId: '1yhnq2WgPh54cY5AxNKuVQ' })
